// extracted by mini-css-extract-plugin
module.exports = {"root":"dd31006766--root--ho9IE","mobile":"dd31006766--mobile--xwcGr","price-type":"dd31006766--price-type--mhijc"};